import { each, find, reduce } from 'lodash';
import React from 'react';
import { unmountComponentAtNode, unstable_renderSubtreeIntoContainer as render } from 'react-dom';
import { GoogleMap, POSITION } from '@zocdoc/components/src/GoogleMap';

import LocationCardCarousel from '../SearchResults/LocationCardCarousel';

class SearchMap extends GoogleMap {
    static displayName = 'SearchMap';

    lastSearchAddress = this.props.searchAddress;

    recenterMap(...args) {
        const differentAddress = this.props.searchAddress !== this.lastSearchAddress;

        if (!this.props.searchByMovingMapEnabled || differentAddress) {
            super.recenterMap(...args);

            if (differentAddress) this.lastSearchAddress = this.props.searchAddress;
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.props.providerLoading) {
            super.componentDidUpdate(prevProps);
        }
    }

    onClickMarker(latlngKey) {
        this.createInfoWindow(latlngKey);
    }

    createInfoWindow(latlngKey) {
        this.removePreviousInfoWindow();

        const marker = this.markers[latlngKey];
        marker.selected = true;
        const matchingProviders = reduce(this.markersByEntityLocationId, (arr, markerRef, id) => {
            if (markerRef === marker) {
                arr.push(
                    find(this.props.entities, { id })
                );
            }

            return arr;
        }, []);

        const hostNode = document.createElement('div');
        this.currentNode = hostNode;

        render(this, <LocationCardCarousel providers={matchingProviders} />, hostNode);

        const iw = new window.google.maps.InfoWindow({ content: hostNode });
        this.currentIw = iw;

        iw.open(this.map, marker);

        const handle = window.google.maps.event.addListener(iw, 'closeclick', () => {
            window.google.maps.event.removeListener(handle);
            unmountComponentAtNode(hostNode);
        });
        this.currentHandle = handle;
    }

    removePreviousInfoWindow() {
        if (this.currentNode) {
            unmountComponentAtNode(this.currentNode);
        }
        each(this.markers, marker => {
            if (marker.selected) {
                marker.selected = false;
                window.google.maps.event.trigger(marker, 'mouseout');
            }
        });
        if (this.currentHandle) {
            window.google.maps.event.removeListener(this.currentHandle);
        }
        if (this.currentIw) {
            this.currentIw.close();
        }
    }
}

export {
    SearchMap as default,
    SearchMap,
    POSITION,
};
